import React from 'react';
import { Icon, Message } from 'semantic-ui-react';
import FormattedHTMLMessage from '@/components/FormattedHTMLMessage';

const ConvertMessage = ({ isDirty }) => (
  <Message warning>
    <Icon name={isDirty ? 'warning' : 'info'} />
    <FormattedHTMLMessage id={isDirty ? 'dataset.attachments.wizard.warning' : 'dataset.attachments.wizard.info'} />
  </Message>
);

export default ConvertMessage;
